'use strict';

export default function f($filter) {
  'ngInject';

  return {
    it(input) {
      if (!input) {
        input = '';
      }
      return $filter('titleCase')($filter('dashesWithSpaces')(input));
    },

    activities(input) {
      return ($filter('dashesWithSpaces')(input)).replace(' and ', ' & ');
    }
  };
}



// WEBPACK FOOTER //
// ./app/src/services/deslug.js